import  { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../hook/useNotification";
import {
 
  getAllCartItems,
  notLoginAddItemToCart,
  removeAllCartItems,
  removeOneItem,
  storeNotLoginCartItems,
  updateItemCart,
} from "../../redux/actions/cartAction";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


const DeleteCartHook = (item) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [itemCount, setSetItemCount] = useState(item && item.quantity);
  const [itemNotes,setItemNotes] = useState(item && item.productNotes)

  const {t} = useTranslation();


  var user = "";
  if (localStorage.getItem("user") != null) {
    user = JSON.parse(localStorage.getItem("user"));
  }

  const handleDeletCart = async () => {

    if (!window.confirm("هل أنت متأكد أنك تريد حذف السلة؟")) return;

    if( !user &&settings?.data?.hasNotLoginCart==true){
        localStorage.removeItem("cart");
        window.location.reload(false);
    }
    else{
        setLoading(true);
        await dispatch(removeAllCartItems(user?._id));
        setLoading(false);
    }
    
  };
  const onChangeCount = (e) => {
    setSetItemCount(e.target.value);
  };

  const onChangeItemNotes = (e) => {
    setItemNotes(e.target.value)
  }

  const res = useSelector((state) => state.cartReducer.deleteAllCartItems);
   const settings = useSelector((state) => state.settingsReducers.settings);





  useEffect(() => {
    if (loading === false) {
      if (res && res.success === true) {
        notify(t("All products have been removed"), "success");
        setTimeout(() => {
          window.location.reload(false);
        }, 1500);
      } else {
      }
    }
  }, [loading]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate()
  const itemsToShow = useSelector((state) => state.cartReducer.notLoginCartItems);

  const handleDeleteItem = async () => {
    // if not login
    if( !user &&settings?.data?.hasNotLoginCart==true){
        console.log('iteeeeeeem',item?.product?._id);
         let cartItems = JSON.parse(localStorage.getItem("cart"));
         let newCartItems = cartItems?.filter((el) => el?.customID !== item?.customID);
         localStorage.setItem("cart", JSON.stringify(newCartItems));

       // let filteredItems = itemsToShow?.filter((el) => el?.id !== item?.id);
       // console.log('filteredItems',filteredItems);

       // localStorage.setItem("cart", JSON.stringify(filteredItems));

        //  dispatch(storeNotLoginCartItems({items:newCartItems}));
        //  // دي عشان الرقم ل ف السلة
        //  dispatch(notLoginAddItemToCart({numberOfItems:newCartItems?.length}));

          setShow(false);
           window.location.reload(false);
    }
    else{
        await dispatch(removeOneItem(item._id));
        setShow(false);
        window.location.reload(false);
    }
  
  };
  const handleUpdateCart = async () => {
    
   if(!user){
    console.log('oooooooooooop');
    return notify(t("Log in first"), "warn");
   } 

    await dispatch(updateItemCart(item._id, { quantity: itemCount , productNotes:itemNotes }));
    window.location.reload(false);
  };




  return [
    handleDeletCart,
    show,
    handleClose,
    handleShow,
    handleDeleteItem,
    itemCount,
    onChangeCount,
    handleUpdateCart,
    itemNotes,
onChangeItemNotes

  ];
};

export default DeleteCartHook;
